<template>
  <div>
    <div class="search-content" style="display: flex">
      <el-form :model="listQuery" class="search-form" size="small">
        <el-form-item label="年份：" label-width="55px" prop="salesScopeId">
          <el-select
            ref="mySel"
            v-model="listQuery.year"
            filterable
            placeholder="请选择年份"
            @change="handleSelectChange"
          >
            <el-option
              v-for="item in lastTenYears"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 操作按钮 -->
    <div class="table-content">
      <div class="handle-btn">
        <el-popover v-model="visible" placement="top" width="270">
          <p class="popover-content">
            当前选择年份为：<span>{{ listQuery.year }}</span
            >，确定编辑吗？
          </p>
          <div style="text-align: right">
            <el-button size="mini" type="text" @click="visible = false"
              >取消</el-button
            >
            <el-button type="primary" size="mini" @click="handleEdit(1)"
              >确定</el-button
            >
          </div>
          <el-button
            v-show="!isEdit"
            slot="reference"
            size="small"
            type="primary"
            >编辑</el-button
          >
          <el-button
            v-show="isEdit"
            slot="reference"
            size="small"
            plain
            @click="handleEdit()"
            >取消编辑</el-button
          >
        </el-popover>

        <el-button size="small" type="primary" @click="handleDownload">
          模板下载
        </el-button>
        <!--        <el-button size="small" type="primary" @click="handleImport"> 导入 </el-button>-->
        <el-upload
          ref="uploadExcel"
          class="upload-btn"
          action=""
          :on-change="handleChange"
          :show-file-list="false"
          :limit="2"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :auto-upload="false"
        >
          <el-button type="primary">导入</el-button>
        </el-upload>

        <el-button size="small" type="primary" @click="submitTableData">
          提交
        </el-button>
      </div>
      <el-table
        v-loading="isTableLoading"
        :data="tableData"
        :height="tableHeight"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <template v-for="(item, index) in tableCol">
          <el-table-column
            v-if="index == 0"
            :key="index + item.prop + item.label"
            align="center"
            min-width="120"
            :label="item.label"
            :prop="item.prop"
            fixed
          >
          </el-table-column>
          <el-table-column
            v-else
            :key="index + item.prop + item.label"
            align="center"
            min-width="145"
            :label="item.label"
          >
            <template slot-scope="scope">
              <el-input
                v-show="isEdit"
                v-model="scope.row[item.prop]"
                size="small"
                placeholder="请输入"
                :maxlength="oprateType == '002' ? '' : 7"
                @keyup.native="
                  scope.row[item.prop] = formatMoney(scope.row[item.prop])
                "
              ></el-input>
              <span v-show="!isEdit">{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
import axios from 'more-request/instance';

import { baseUrl } from '../../api/config';
import Api from '../../api/valveDataImport';

const currentYear = new Date().getFullYear();
export default {
  name: 'Common',
  components: {},
  props: {
    isTableLoading: {
      type: Boolean,
      required: true,
    },
    oprateType: {
      type: String,
      required: true,
    },
    tableData: {
      type: Array,
      default: () => {},
      required: true,
    },
    lastTenYears: {
      type: Array,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      isEdit: false,
      listQuery: {
        year: currentYear,
      },
      copyYear: currentYear,
      tableHeight: 600,
      tableCol: [
        { label: '产品名称', prop: 'productName' },
        { label: '一月', prop: 'month1' },
        { label: '二月', prop: 'month2' },
        { label: '三月', prop: 'month3' },
        { label: '四月', prop: 'month4' },
        { label: '五月', prop: 'month5' },
        { label: '六月', prop: 'month6' },
        { label: '七月', prop: 'month7' },
        { label: '八月', prop: 'month8' },
        { label: '九月', prop: 'month9' },
        { label: '十月', prop: 'month10' },
        { label: '十一月', prop: 'month11' },
        { label: '十二月', prop: 'month12' },
      ],
      fileTemp: null,
    };
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleSelectChange(v) {
      if (this.isEdit) {
        this.$confirm(
          '年份切换会将您填写的数据进行删除，是否进行切换',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            this.$refs.mySel.handleClose();
            this.reset();
            this.copyYear = v;
            this.$emit('getData', v);
          })
          .catch(() => {
            this.$refs.mySel.handleClose();
            this.listQuery.year = this.copyYear;
          });
      } else {
        this.$emit('getData', v);
        this.copyYear = v;
      }
    },
    handleDownload() {
      const params = {
        oprateType: this.oprateType,
        statYear: this.listQuery.year,
      };
      Api.exportValveZoneDataInfo(params).then((res) => {
        if (res.code == '200') {
          window.open(Api.getValveZoneDownloadData(res.data.fileUrl));
        } else {
          this.$message.error('失败！');
        }
      });
    },
    // excel表上传
    handleChange(file) {
      // 解决element-ui第二次上传时on-change事件没有执行的问题
      if (this.$refs.uploadExcel.uploadFiles.length > 1) {
        this.$refs.uploadExcel.uploadFiles.shift();
      }
      this.fileTemp = file.raw;
      const fileName = file.raw.name;
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1);
      // 判断上传文件格式
      if (this.fileTemp) {
        if (fileType == 'xlsx') {
          this.handleImport();
        } else {
          this.$message({
            type: 'warning',
            message: '附件格式错误，请删除后重新上传！',
          });
        }
      } else {
        this.$message({
          type: 'warning',
          message: '请上传附件！',
        });
      }
    },
    handleImport() {
      const formData = new FormData();
      formData.append('file', this.fileTemp);
      formData.append('oprateType', this.oprateType);
      formData.append('statYear', this.listQuery.year);
      axios({
        method: 'POST',
        url: `${baseUrl}/memberportal/zh/api/zone/valvezone/uploadValveZoneExcel.do`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data;charset=utf-8',
        },
      })
        .then((res) => {
          if (res.status == 200) {
            if (res.data.data.success) {
              this.handleSuccess();
              this.handleRemove();
              this.$emit('getData', this.listQuery.year);
            } else {
              this.handleRemove();
              this.handleError(res.data.data.message);
            }
          } else {
            this.handleRemove();
            this.handleError(res.data.data.message);
          }
        })
        .catch(() => {
          this.handleRemove();
          this.handleError();
        });
    },
    handleSuccess() {
      this.$message.success('文件导入成功！');
    },
    // 移除excel表
    handleRemove() {
      this.fileTemp = null;
    },
    handleError(errMsg) {
      this.$message.error(errMsg || '文件导入失败！');
    },
    handleEdit(flag) {
      this.visible = false;
      this.isEdit = !!flag;
      if (!flag) {
        // 取消编辑时，页面数据初始化
        this.$emit('getData', this.listQuery.year);
      }
    },
    submitTableData() {
      const saveData = [];
      this.tableData.map((obj) => {
        const { productName } = obj;
        const { productCode } = obj;
        Object.keys(obj).forEach((item) => {
          if (item.indexOf('month') > -1) {
            const cell = {
              statYear: this.listQuery.year,
              statMonth: item.split('month')[1],
              productName,
              productCode: Number(productCode),
              price: obj[item],
            };
            saveData.push(cell);
          }
        });
      });
      this.reset();
      this.$emit('submitTableData', { saveData, y: this.listQuery.year });
    },
    formatMoney(value) {
      let v = value;
      if (this.oprateType == '002') {
        // 价格走势只能输入正整数和小数，小数最多保留2位小数
        // v = v.replace(/[^\d.]/g,""); // 清除"数字"和"."以外的字符
        v = v.replace(/^\./g, ''); // 验证第一个字符是数字
        v = v.replace(/\.{2,}/g, '.'); // 只保留第一个, 清除多余的
        // v = v.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        // v = v.replace(/^()*(\d+)\.(\d\d).*$/,'$1$2.$3'); // 只能输入2位小数
        if (v.indexOf('.') > -1) {
          const start = v.split('.')[0].match(/\d{0,13}/)[0];
          const end = v.split('.')[1].match(/\d{0,2}/)[0];
          v = `${start}.${end}`;
        } else {
          v = v.match(/\d{0,13}/)[0];
        }
      } else {
        // 只能输入正整数
        v = v.replace(/[^0-9]/g, '');
      }
      return v;
    },
    reset() {
      this.isEdit = false;
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-content {
  padding: 20px 20px 0;
  margin-bottom: 10px;
  width: 100%;
  border-top: 1px solid #d9d9d9;
  position: relative;
  top: -1px;
  //display: flex;
  background: #fff;
  .tips {
    width: 100%;
    min-height: 44px;
    line-height: 44px;
    background: #e8efff;
    box-sizing: border-box;
    padding: 0 20px;
    margin: 10px 0;
    font-size: 16px;
    color: #333;
    .color {
      color: #ef4c56;
      font-weight: bold;
    }
  }
  .search-form {
    .el-form-item {
      flex: 0 0 316px;
    }
    .el-input {
      width: 186px;
    }
  }
  .search-btn {
    text-align: center;
    margin-left: 50px;
  }
}
.table-content {
  padding: 20px;
  background: #fff;
  .handle-btn {
    padding-bottom: 20px;
    display: flex;
    .el-popover__reference-wrapper {
      .el-button {
        margin-right: 10px;
      }
    }
    .upload-btn {
      margin: 0 10px;
    }
    .el-button--small {
      padding: 10px 15px;
    }
  }
}
.popover-content {
  margin: 10px 0;
  span {
    font-weight: 600;
    color: #f00;
  }
}
</style>
<style lang="scss">
.table-content {
  .el-table__body-wrapper {
    overflow-y: auto;
  }
}
</style>
